import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Media,
  Row,
  Spinner,
  Table,
} from "reactstrap";
// core components
import OnlyHeader from "components/Headers/OnlyHeader.js";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { getWorkTypeAction } from "store/actions/workTypeActions";
import { workTypeSearchByTitleAction } from "store/actions/workTypeActions";
import DeleteEquipmentWorkModal from "components/Modals/equipmentModals/DeleteEquipmentWorkModal";
import EquipmentWorkModal from "components/Modals/equipmentModals/EquipmentWorkModal";
import { toast } from "react-toastify";
const WorkTypes = () => {
  const { allWorkTypes, getWorkTypeLoader, totalPages } = useSelector(
    (state) => state.worktypes
  );
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [isDeleteModalOpen, setDeleteSubModalOpen] = useState(false);
  const [selectedWorkType, setSelectedWorkType] = useState("");
  const [workSearchTitle, setWorkSearchTitle] = useState("");

  const itemsPerPage = 10;
  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleDeleteModal = (id) => {
    setSelectedWorkType(id);
    setDeleteSubModalOpen(!isDeleteModalOpen);
  };
  const handleAddWorkType = () => {
    setIsEdit(false);
    setSelectedWorkType(null);
    toggle();
  };

  const handleEditWorkType = (worktype) => {
    setIsEdit(true);
    setSelectedWorkType(worktype);
    toggle();
  };
  const handleOnSumbit = () => {
    if(!workSearchTitle){
      toast.error('WorkType not provided');
      return;
    }
    dispatch(workTypeSearchByTitleAction(workSearchTitle));
  };

  const handleClearSearch = () => {
    setWorkSearchTitle("");
    dispatch(getWorkTypeAction());
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
    });
    return formattedDate;
  };

  useEffect(() => {
    dispatch(getWorkTypeAction(currentPage, itemsPerPage));
  }, [dispatch, currentPage, itemsPerPage]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row className="mb-5">
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="d-flex flex-column justify-content-between align-items-center flex-xl-row">
                  <Col className="col-12 col-lg-3">
                    <h3 className="text-center text-xl-left">Work Types</h3>
                  </Col>
                  <Col className="d-flex flex-column flex-lg-row justify-content-around align-items-center align-items-lg-start">
                    <div className="w-100 w-sm-50">
                      <FormGroup className="mb-0 w-100">
                        <Input
                          id="ResolutionSearch"
                          name="Search"
                          placeholder="Search Here..."
                          type="text"
                          value={workSearchTitle}
                          onChange={(e) => setWorkSearchTitle(e.target.value)}
                        />
                      </FormGroup>
                      <small className="text-xs text-primary">
                        Search by WorkType
                      </small>
                    </div>
                    <div>
                      <Button
                        color="primary"
                        className="px-10 py-2 mx-1 my-2 my-lg-0"
                        disabled={getWorkTypeLoader}
                        onClick={handleOnSumbit}
                        size="sm"
                      >
                        Search
                      </Button>
                      <Button
                        color="primary"
                        className="p-2 mx-1 my-2 my-lg-0"
                        size="sm"
                        disabled={getWorkTypeLoader || !workSearchTitle}
                        onClick={handleClearSearch}
                      >
                        Clear Search
                      </Button>
                      <Button
                        color="primary"
                        className="p-2 mx-1 my-2 my-lg-0"
                        size="sm"
                        onClick={handleAddWorkType}
                      >
                        Add New WorkType
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Created At</th>
                    <th scope="col">Updated At</th>
                    <th scope="col">WorkType</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                {!getWorkTypeLoader ? (
                  <tbody>
                    {allWorkTypes && allWorkTypes.length > 0 ? (
                      allWorkTypes?.map((worktype, index) => (
                        <tr key={index}>
                          <td scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {formatTimestamp(worktype?.createdAt)}
                                </span>
                              </Media>
                            </Media>
                          </td>
                          <td scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {formatTimestamp(worktype?.updatedAt)}
                                </span>
                              </Media>
                            </Media>
                          </td>
                          <td scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {worktype?.name}
                                </span>
                              </Media>
                            </Media>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <Button
                                color="success"
                                size="sm"
                                onClick={() => handleEditWorkType(worktype)}
                              >
                                <i className="fas fa-pencil-alt" />
                              </Button>
                              <Button
                                color="danger"
                                className="mx-2"
                                size="sm"
                                onClick={() => handleDeleteModal(worktype._id)}
                              >
                                <i className="fa fa-trash"></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>
                          {allWorkTypes && allWorkTypes.length === 0 ? (
                            <p className="mb-0 text-sm">No Skill found.</p>
                          ) : (
                            <Spinner
                              size="lg"
                              style={{
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        <Spinner
                          size="lg"
                          style={{
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
              {totalPages > 0 && (
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={handlePageChange}
                      containerClassName={
                        "pagination px-1 justify-content-end mb-0"
                      }
                      activeClassName={"active"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      nextClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextLinkClassName={"page-link"}
                    />
                  </nav>
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>
      </Container>

      <DeleteEquipmentWorkModal
        SearchTitle={workSearchTitle}
        modal={isDeleteModalOpen}
        toggle={() => handleDeleteModal()}
        id={selectedWorkType}
        type="worktype"
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />
      <EquipmentWorkModal
        modal={modal}
        toggle={toggle}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        isEdit={isEdit}
        type="worktype"
        item={selectedWorkType}
        SearchTitle={setWorkSearchTitle}
      />
    </>
  );
};

export default WorkTypes;
